const declension = (number, words) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return words[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[Math.min(number % 10, 5)]
  ];
};


export const requestword = (number) => {
    const words = ['заявка', 'заявки', 'заявок'];
    return declension(number, words);
}

export const kindergartenscountword = (number) => {
    const words = ['садочок','садочка','садочків'];
    return declension(number, words);
}

export const filterscountword = (number) => {
    const words = ['фільтр','фільтри','фільтрів'];
    return declension(number, words);
}

export const childrenscount = (number) => {
    const words = ['дитина', 'дитини', 'дітей'];
    return declension(number, words);
}